function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7167 18.3599C17.7751 18.3599 16.8895 17.9932 16.2238 17.3277L12.624 13.728C12.3713 13.4746 11.9308 13.4754 11.6781 13.728L8.06524 17.3409C7.39936 18.0063 6.5138 18.373 5.57214 18.373H4.86279L9.42185 22.9322C10.8457 24.3559 13.1543 24.3559 14.5782 22.9322L19.1504 18.3599H18.7167Z",
  fill: "#32BCAD"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.57203 5.62699C6.51369 5.62699 7.39925 5.99374 8.06503 6.65929L11.6779 10.2727C11.9381 10.5329 12.363 10.5341 12.6239 10.2724L16.2236 6.67238C16.8895 6.00683 17.775 5.64019 18.7167 5.64019H19.1503L14.5781 1.06804C13.1542 -0.355845 10.8457 -0.355845 9.42176 1.06804L4.86279 5.62699H5.57203Z",
  fill: "#32BCAD"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9321 9.42229L20.1691 6.65926C20.1082 6.68364 20.0424 6.69888 19.9729 6.69888H18.7167C18.0672 6.69888 17.4315 6.96224 16.9726 7.42145L13.3728 11.0213C13.0361 11.3581 12.5935 11.5268 12.1512 11.5268C11.7086 11.5268 11.2663 11.3581 10.9295 11.0216L7.31626 7.40835C6.85728 6.94914 6.22164 6.68579 5.57212 6.68579H4.02745C3.96164 6.68579 3.9 6.67021 3.84187 6.64831L1.06792 9.42229C-0.355972 10.8461 -0.355972 13.1547 1.06792 14.5787L3.84176 17.3525C3.89989 17.3306 3.96164 17.3151 4.02745 17.3151H5.57212C6.22164 17.3151 6.85728 17.0517 7.31626 16.5925L10.9291 12.9796C11.5822 12.3271 12.7205 12.3268 13.3728 12.9799L16.9726 16.5793C17.4315 17.0386 18.0672 17.302 18.7167 17.302H19.9729C20.0425 17.302 20.1082 17.3171 20.1692 17.3415L22.9321 14.5787C24.356 13.1547 24.356 10.8461 22.9321 9.42229Z",
  fill: "#32BCAD"
});
function SvgIconPix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPix);
export default __webpack_public_path__ + "static/media/icon-pix.6d53125a4d1d3e79e69e7f11f09ef502.svg";
export { ForwardRef as ReactComponent };